'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PatchResolver = PatchResolver;

var _parseMultipartHttp2 = require('./parseMultipartHttp');

function PatchResolver(_ref) {
    var onResponse = _ref.onResponse,
        boundary = _ref.boundary;

    this.boundary = boundary || '-';
    this.onResponse = onResponse;
    this.processedChunks = 0;
    this.chunkBuffer = '';
}

PatchResolver.prototype.handleChunk = function (data) {
    this.chunkBuffer += data;

    var _parseMultipartHttp = (0, _parseMultipartHttp2.parseMultipartHttp)(this.chunkBuffer, this.boundary),
        newBuffer = _parseMultipartHttp.newBuffer,
        parts = _parseMultipartHttp.parts;

    this.chunkBuffer = newBuffer;
    if (parts.length) {
        this.onResponse(parts);
    }
};